// Source https://github.com/sindresorhus/p-retry/blob/master/index.js
// Imported this way, because npm is not es5 compatible (class)

// @ts-expect-error: Flow to TS migration.
import * as retry from "retry"

import { AbortError, FetchError } from "./fetchErrors"

const promiseRetry: <T>(arg1: () => Promise<T>, arg2: retry.OperationOptions) => Promise<T> = (
  input,
  opts,
) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new Promise((resolve: (result: unknown) => void, reject: (error?: any) => void) => {
    const operation = retry.operation(opts)

    // @ts-expect-error: Flow to TS migration.
    operation.attempt((attempts) => {
      Promise.resolve(attempts)
        .then(input)
        .then(resolve, (err) => {
          if (err instanceof AbortError) {
            operation.stop()
            reject(err.originalError)
          } else if (
            err instanceof TypeError ||
            (err instanceof FetchError && err.status === 400)
          ) {
            operation.stop()
            reject(err)
          } else if (!operation.retry(err)) {
            reject(operation.mainError())
          }
        })
    })
  })

export default promiseRetry
